<template>
  <div>
    <!-- 删除文件 开始 -->
    <div class="in-delete">
      <i class="iconfont icon-sp_tixing"></i>
      <p>删除提醒</p>
      <!-- <p v-if="!modalInfo.length">确定要删除吗?</p>
      <p v-if="modalInfo.length > 0">
        你确定要删除文件
        <span style="display:block"
              v-for="(i, index) in modalInfo"
              :key="index">{{i.FileName}}</span>
      </p> -->
      <p>确定要删除吗?</p>
      <el-button @click="deletefile">删除</el-button>
      <el-button @click="cancle">取消</el-button>
    </div>
    <!-- 删除文件 结束 -->
  </div>
</template>
<script>
import ApiService from '@/services/API-services'
export default {
  name: 'deletefile',
  data() {
    return {
      fileNames: true,
      fileNameArr: null
    }
  },
  props: {
    modalInfo: null
  },
  created() {
    console.log(this.modalInfo)
  },
  methods: {
    cancle() {
      this.$store.commit('closeModal', 'deletefile')
    },
    // 删除文档
    deletefile() {
      // if (this.modalInfo.length === 1) {
      //   params = this.modalInfo[0].FileId
      // } else if (!this.modalInfo.length) {
      //   params = this.modalInfo.FileId
      // } else {
      //   this.modalInfo.map(n => {
      //     paramsArray.push(n.FileId)
      //     return String(paramsArray)
      //   })
      //   params = paramsArray
      // }
      let fileList = [],self = this
      let folderList = []
      if (!this.modalInfo.length) {
        this.modalInfo.FolderId
          ? folderList.push(this.modalInfo.FolderId)
          : fileList.push(this.modalInfo.FileId)
      } else {
        this.modalInfo.map(n => {
          if (n.FileId) {
            fileList.push(n.FileId)
          } else if (n.FolderId) {
            folderList.push(n.FolderId)
          }
        })
      }
      ApiService.oct_doc
        .deleteFile({
          FileIdList: fileList,
          FolderIdList: folderList,
          Token: sessionStorage.octopus_token
        })
        .then(res => {
          if (res.result == 0) {
            ApiService.doc
              .fileDelete({
                FID: String(fileList)
              })
              .then(res => {
                if (res.code == 0) {
                  if(self.modalInfo[0].FileNamePath.split('\\')[0].indexOf('PersonalRoot') >= 0){
                    self.$bus.$emit('comPersonSize', self.modalInfo)
                  }
                  this.$message({
                    message: '删除成功',
                    type: 'success'
                  })
                }
              })
          } else {
            this.$message({
              message: '删除失败',
              type: 'error'
            })
          }
          this.$store.commit('reloadFile', Math.random())
          this.$store.commit('closeModal', 'deletefile')
        })
    }
  }
}
</script>
<style lang="scss">
.in-delete {
  width: 398px;
  border-radius: 2px;
  position: absolute;
  background: #fff;
  top: 20%;
  left: 25%;
  padding: 30px 0;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  i {
    font-size: 50px;
    color: rgb(255, 162, 0);
  }

  p:nth-child(2) {
    color: #003580;
    font-family: 'Microsoft YaHei-Bold';
    font-size: 18px;
  }

  p:nth-child(3) {
    margin-top: 10px;
    font-size: 14px;
    color: #333;
  }

  .el-button {
    width: 148px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    color: #fff;
    background: #2d61a8;
    border-radius: 2px;
    margin-top: 30px;
    padding: 0;
    border: 0;
  }
  i {
    color: rgb(242, 148, 23);
  }

  .el-button:last-child {
    background: #fff;
    border: 1px solid rgb(229, 229, 229);
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mind/deleteFile.vue